export default __webpack_public_path__ + "static/hyundai-logo-f5db162a34f7d73b0c4555c241a0ad14.svg";